import NotificationsIcon from "@mui/icons-material/Notifications";
import { Badge, IconButton, Popover } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearAllNotifications,
  fetchNotifications,
  fetchUnreadCount,
  markNotificationsRead,
  removeNotification,
} from "../store/slices/notificationSlice";
import NotificationPanel from "./NotificationPanel";

const NotificationBell = ({ iconButtonSx }) => {
  const dispatch = useDispatch();
  const { items, unreadCount, loading, hasMore, page } = useSelector(
    (state) => state.notifications,
  );

  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    dispatch(fetchUnreadCount());
  }, [dispatch]);

  const open = Boolean(anchorEl);

  const sortedItems = useMemo(() => {
    return [...items].sort(
      (a, b) =>
        new Date(b.created_on).getTime() - new Date(a.created_on).getTime(),
    );
  }, [items]);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    dispatch(fetchNotifications({ page: 1, limit: 20 }));
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLoadMore = () => {
    if (loading) return;
    dispatch(fetchNotifications({ page: page + 1, limit: 20 }));
  };

  const handleMarkAllRead = () => {
    dispatch(markNotificationsRead({ ids: [] }));
  };

  const handleClearAll = () => {
    const allIds = sortedItems.map((item) => item.notification_id);
    if (allIds.length > 0) {
      dispatch(clearAllNotifications(allIds));
    }
  };

  const handleNotificationClick = (item) => {
    if (!item.is_read) {
      dispatch(markNotificationsRead({ ids: [item.notification_id] }));
    }
  };

  const handleDelete = (id) => {
    dispatch(removeNotification(id));
  };

  return (
    <>
      <IconButton
        color="inherit"
        aria-label="Open notifications"
        onClick={handleOpen}
        sx={iconButtonSx}
      >
        <Badge color="error" badgeContent={unreadCount} max={99}>
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <NotificationPanel
          notifications={sortedItems}
          loading={loading}
          hasMore={hasMore}
          onLoadMore={handleLoadMore}
          onMarkAllRead={handleMarkAllRead}
          onClearAll={handleClearAll}
          onNotificationClick={handleNotificationClick}
          onNotificationDelete={handleDelete}
        />
      </Popover>
    </>
  );
};

NotificationBell.propTypes = {
  iconButtonSx: PropTypes.object,
};

export default NotificationBell;
